import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	buttonLabel: {
		id: 'software-releases-approvers.task-approver.approval-status.button-label',
		defaultMessage: 'Approval state dropdown',
		description: 'Label for select trigger button icon',
	},
	approveOptionLabel: {
		id: 'software-releases-approvers.task-approver.approval-status.approve-option-label',
		defaultMessage: 'Approve',
		description: 'The approval option for the status menu',
	},
	revokeApprovalOptionLabel: {
		id: 'software-releases-approvers.task-approver.approval-status.revoke-approval-option-label',
		defaultMessage: 'Revoke approval',
		description: 'The option label to revoke approval status for the status menu',
	},
	declineOptionLabel: {
		id: 'software-releases-approvers.task-approver.approval-status.decline-option-label',
		defaultMessage: 'Decline',
		description: 'The decline option for the status menu',
	},
	genericUpdateFailedFlagTitle: {
		id: 'software-releases-approvers.task-approver.approval-status.generic-update-failed-flag-title',
		defaultMessage: 'Something went wrong',
		description: 'The title of the error flag when updating the task approval status fails',
	},
	statusFailedFlagDescription: {
		id: 'software-releases-approvers.task-approver.approval-status.status-failed-flag-description',
		defaultMessage:
			'We were not able to update the approval status. Please refresh the page and try again.',
		description: 'The description of the error flag when approval status update fails',
	},
});
